import { httpClient } from "@/lib/http-client/http-client";
import { API_ROUTES } from "@/shared/constants/api.routes";
import {
  GetDocumentAnswerProcessDetailRequest,
  GetDocumentAnswerProcessesRequest,
  StartDocumentAnswerProcessRequest,
} from "@/shared/services/interface/requests/document-answer-process";
import {
  DocumentAnswerProcessDetail,
  DocumentAnswerProcessListItem,
  StartDocumentAnswerProcessResponse,
} from "@/shared/services/interface/responses/document-answer-process";

class DocumentAnswerProcessService {
  async startProcess(request: StartDocumentAnswerProcessRequest) {
    const { specificationId, productId, fileId } = request;
    return httpClient.post<StartDocumentAnswerProcessResponse>(
      API_ROUTES.SpecificationSupplierResponses.documentAnswerProcesses(specificationId),
      { productId, fileId }
    );
  }

  async listProcesses(request: GetDocumentAnswerProcessesRequest) {
    const { specificationId } = request;
    return httpClient.get<DocumentAnswerProcessListItem[]>(
      API_ROUTES.SpecificationSupplierResponses.documentAnswerProcesses(specificationId)
    );
  }

  async getProcessDetail(request: GetDocumentAnswerProcessDetailRequest) {
    const { specificationId, manuelProcessId } = request;
    return httpClient.get<DocumentAnswerProcessDetail>(
      API_ROUTES.SpecificationSupplierResponses.documentAnswerProcessDetail(
        specificationId,
        manuelProcessId
      )
    );
  }
}

export const documentAnswerProcessService = new DocumentAnswerProcessService();
export default DocumentAnswerProcessService;

